// import React, { FC, useEffect, useMemo, useState } from 'react';
// import Section from '@widgets/components/section';
// import { Table, TableBody, TableTd, TableTh, TableThead, TableTr } from '@widgets/table';
// import { MONTHS_FULL, MONTHS_FULL_FOR_SELECT } from '@app/contstants/months';
// import SingleSelect from '@widgets/single-select';
// import {
//   IManagerSalaryTableList,
//   useManagerSalaryTableList,
// } from '@app/queries/managers-performance/useManagerSalaryTableList';
// import { IManager } from '@entities/managersPerformance/IManager';
// import { useManagerSalary } from '@app/queries/managers-performance/useManagerSalary';
// import { IManagerSalary } from '@entities/managersPerformance/IManagerSalary';
// import IconEdit from '@shared/icons/IconEdit';
// import { TextInput } from '@shared/uikit/input-text';
// import { BlueTransparentButton, RedTransparentButton } from '@shared/uikit/button';
// import { Loader } from '@shared/uikit/loader';
// import { toast } from 'react-toastify';
// import { useCreateManagerSalary } from '@app/queries/managers-performance/useCreateManagerSalary';
// import { useEditManagerSalary } from '@app/queries/managers-performance/useEditManagerSalary';

// interface IManagerSalaryInfo {
//   manager: IManager;
// }

// export const SalaryInfo: FC<IManagerSalaryInfo> = ({ manager }) => {
//   const managerSalaryTableListFetcher = useManagerSalaryTableList();
//   const managerSalaryFetcher = useManagerSalary();
//   const createManagerSalaryFetcher = useCreateManagerSalary();
//   const editManagerSalaryFetcher = useEditManagerSalary();

//   const [managerSalaryTableList, setManagersSalaryTableList] =
//     useState<IManagerSalaryTableList | null>(null);
//   const [managerSalary, setManagersSalary] = useState<IManagerSalary | null>(null);
//   const [monthPlanValue, setMonthPlanValue] = useState<number>(new Date().getMonth() + 1);

//   const [isEditing, setEditing] = useState<boolean>(false);
//   const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
//   const [salary, setSalary] = useState<string>('');
//   const [penalty, setPenalty] = useState<string>('');
//   const [bonus, setBonus] = useState<string>('');
//   const [additionalBonus, setAdditionalBonus] = useState<string>('');

//   useEffect(() => {
//     (async () => {
//       if (null === manager) return;

//       const data = await managerSalaryTableListFetcher.fetch({
//         month: monthPlanValue,
//         managerId: manager.id,
//       });

//       setManagersSalaryTableList(data);
//     })();
//   }, [manager, monthPlanValue]);

//   useEffect(() => {
//     (async () => {
//       if (null === manager) return;

//       const data = await managerSalaryFetcher.fetch({
//         month: monthPlanValue,
//         managerId: manager.id,
//       });

//       setSalary(data.salary ?? '');
//       setPenalty(data.penalty ?? '');
//       setBonus(data.bonus ?? '');
//       setAdditionalBonus(data.addinional_bonus ?? '');
//       setManagersSalary(data);
//     })();
//   }, [manager, monthPlanValue, isEditing]);

//   const totals = useMemo(() => {
//     const init = { hashrate: 0, referral: 0, to_pay: 0 };
//     if (!managerSalaryTableList?.items?.length) return init;

//     return managerSalaryTableList.items.reduce((acc, it) => {
//       acc.hashrate += Number(it.hashrate || 0);
//       acc.referral += Number(it.referral_interest || 0);
//       acc.to_pay += Number(it.to_pay || 0);
//       return acc;
//     }, init);
//   }, [managerSalaryTableList]);

//   const updateSalary = async () => {
//     if (null === managerSalary?.id) {
//       await createManagerSalaryFetcher.fetch({
//         managerId: manager.id,
//         year: new Date().getFullYear(),
//         month: monthPlanValue,
//         salary: salary,
//         bonus: bonus,
//         additionalBonus: additionalBonus,
//         penalty: penalty,
//       });

//       toast.success('Данные успешно добавлены');
//     } else {
//       if (!managerSalary?.id) {
//         return;
//       }

//       await editManagerSalaryFetcher.fetch({
//         salaryId: managerSalary.id,
//         managerId: manager.id,
//         year: new Date().getFullYear(),
//         month: monthPlanValue,
//         salary: salary,
//         bonus: bonus,
//         additionalBonus: additionalBonus,
//         penalty: penalty,
//       });

//       toast.success('Данные успешно обновлены');
//     }

//     setEditing(false);
//     setIsSubmitting(false);
//   };

//   return (
//     <>
//       <Section>
//         <div className="flex items-center justify-between w-full mb-[10px] white">
//           <span className="font-semibold text-[20px]">Таблица</span>
//           <SingleSelect
//             value={{
//               value: monthPlanValue.toString(),
//               label: MONTHS_FULL[monthPlanValue - 1],
//             }}
//             title=""
//             isLoading={false}
//             options={MONTHS_FULL_FOR_SELECT}
//             onChange={option => {
//               setMonthPlanValue(+option?.value);
//             }}
//             textSize="16px"
//             hideClearIcon={true}
//           />
//         </div>
//         <Table>
//           <TableThead>
//             <TableTr>
//               <TableTh title="Аккаунт" className="w-[20%]" />
//               <TableTh title="Дата начала майнинга" className="w-[20%]" />
//               <TableTh title="Хешрейт за пред. период" className="w-[20%]" />
//               <TableTh title="Хешрейт за тек. период" className="w-[20%]" />
//               <TableTh title="% Interhash" className="w-[10%]" />
//               <TableTh title="Flex" className="w-[10%]" />
//             </TableTr>
//           </TableThead>
//           <TableBody>
//             {managerSalaryTableList &&
//               managerSalaryTableList.items.map((item, index) => (
//                 <TableTr key={index}>
//                   <TableTd title={item.account} />
//                   <TableTd title={item.started_date} />
//                   <TableTd title={item.max_hashrate + ' Ph'} />
//                   <TableTd title={item.hashrate + ' Ph'} />
//                   <TableTd title={item.referral_interest + '%'} />
//                   <TableTd title={item.to_pay.toString()} />
//                 </TableTr>
//               ))}
//             <TableTr key={'total'} withoutUnderline={true}>
//               <TableTd title={''} />
//               <TableTd title={''} />
//               <TableTd title={''} />
//               <TableTd
//                 title={
//                   <span style={{ color: '#D7F525' }}>{`${totals.hashrate.toFixed(2)} Ph`}</span>
//                 }
//               />
//               <TableTd
//                 title={<span style={{ color: '#D7F525' }}>{`${totals.referral.toFixed(2)}%`}</span>}
//               />
//               <TableTd
//                 title={<span style={{ color: '#D7F525' }}>{totals.to_pay.toFixed(2)}</span>}
//               />
//             </TableTr>
//           </TableBody>
//         </Table>
//       </Section>

//       <Section>
//         <div className="flex items-center justify-between text-[20px] mb-[20px]">
//           <span className="font-semibold text-[20px]">Расчёт</span>
//           <button
//             className="w-[20px] h-[20px]"
//             onClick={() => {
//               setEditing(true);
//             }}
//           >
//             <IconEdit height="20" width="20" />
//           </button>
//         </div>
//         <div className="grid md:grid-cols-4 gap-8">
//           <div className="w-full">
//             <div className="mb-[10px] text-[#959595]">Фикс</div>
//             <div
//               style={{
//                 backgroundColor: isEditing ? '#211F24' : '#141316',
//               }}
//               className={`h-[39px] w-full rounded-[8px] text-[12px] px-[10px] flex items-center border border-solid border-[#2B292F]`}
//             >
//               {isEditing ? (
//                 <div className="w-full flex items-center text-[16px]">
//                   <TextInput
//                     width="100%"
//                     value={`${salary}`}
//                     bgColor="#211F24"
//                     borderColor="#211F24"
//                     onChange={(value: string) => setSalary(value)}
//                     decimalFormattingMode={true}
//                   />
//                 </div>
//               ) : (
//                 <span className="text-[16px]">$ {managerSalary?.salary}</span>
//               )}
//             </div>
//           </div>
//           <div className="w-full">
//             <div className="mb-[10px] text-[#959595]">Флекс</div>
//             <div
//               className={`h-[39px] w-full rounded-[8px] text-[12px] bg-[#141316] px-[10px] flex items-center border border-solid border-[#2B292F]`}
//             >
//               <span className="text-[16px]">{managerSalary?.flex}</span>
//             </div>
//           </div>
//           <div className="w-full">
//             <div className="mb-[10px] text-[#959595]">Бонус</div>
//             <div
//               style={{
//                 backgroundColor: isEditing ? '#211F24' : '#141316',
//               }}
//               className={`h-[39px] w-full rounded-[8px] text-[12px] px-[10px] flex items-center border border-solid border-[#2B292F]`}
//             >
//               {isEditing ? (
//                 <div className="w-full flex items-center text-[16px]">
//                   <TextInput
//                     width="100%"
//                     value={`${bonus}`}
//                     bgColor="#211F24"
//                     borderColor="#211F24"
//                     onChange={(value: string) => setBonus(value)}
//                     decimalFormattingMode={true}
//                   />
//                 </div>
//               ) : (
//                 <span className="text-[16px]">{managerSalary?.bonus}</span>
//               )}
//             </div>
//           </div>
//           <div className="w-full">
//             <div className="mb-[10px] text-[#959595]">Штраф</div>
//             <div
//               style={{
//                 backgroundColor: isEditing ? '#211F24' : '#141316',
//               }}
//               className={`h-[39px] w-full rounded-[8px] text-[12px] bg-[#141316] px-[10px] flex items-center border border-solid border-[#2B292F]`}
//             >
//               {isEditing ? (
//                 <div className="w-full flex items-center text-[16px]">
//                   <TextInput
//                     width="100%"
//                     value={`${penalty}`}
//                     bgColor="#211F24"
//                     borderColor="#211F24"
//                     onChange={(value: string) => setPenalty(value)}
//                     decimalFormattingMode={true}
//                   />
//                 </div>
//               ) : (
//                 <span className="text-[16px]">{managerSalary?.penalty}</span>
//               )}
//             </div>
//           </div>
//           <div className="w-full">
//             <div className="mb-[10px] text-[#959595]">Доп. продажи</div>
//             <div
//               style={{
//                 backgroundColor: isEditing ? '#211F24' : '#141316',
//               }}
//               className={`h-[39px] w-full rounded-[8px] text-[12px] px-[10px] flex items-center border border-solid border-[#2B292F]`}
//             >
//               {isEditing ? (
//                 <div className="w-full flex items-center text-[16px]">
//                   <TextInput
//                     width="100%"
//                     value={`${additionalBonus}`}
//                     bgColor="#211F24"
//                     borderColor="#211F24"
//                     onChange={(value: string) => setAdditionalBonus(value)}
//                     decimalFormattingMode={true}
//                   />
//                 </div>
//               ) : (
//                 <span className="text-[16px]">{managerSalary?.addinional_bonus}</span>
//               )}
//             </div>
//           </div>
//           <div className="w-full">
//             <div className="mb-[10px] text-[#959595]">Итого к выплате</div>
//             <div
//               className={`h-[39px] w-full rounded-[8px] text-[12px] bg-[#141316] px-[10px] flex items-center border border-solid border-[#2B292F]`}
//             >
//               <span className="text-[16px]">{managerSalary?.total}</span>
//             </div>
//           </div>
//           {isEditing ? (
//             <>
//               <div className="w-[100%] mt-auto">
//                 {!isSubmitting ? (
//                   <RedTransparentButton
//                     height="39px"
//                     onClick={() => {
//                       setEditing(false);
//                     }}
//                     title="Отменить"
//                   />
//                 ) : null}
//               </div>
//               <div className="w-[100%] mt-auto">
//                 <BlueTransparentButton
//                   height="39px"
//                   onClick={() => {
//                     setIsSubmitting(true);
//                     if (!isSubmitting) updateSalary();
//                   }}
//                   title={
//                     isSubmitting ? (
//                       <Loader size={30} position="center" loading={isSubmitting} />
//                     ) : (
//                       'Сохранить'
//                     )
//                   }
//                 />
//               </div>
//             </>
//           ) : (
//             <>
//               <div />
//               <div />
//             </>
//           )}
//         </div>
//       </Section>
//     </>
//   );
// };

import { useState } from 'react';
import { SalaryTable } from './salary-table';
// import { SalaryCalculation } from './salary-calculation';

type Props = {
  managerId: number | null;
};

export const SalaryInfo = ({ managerId }: Props) => {
  const [month, setMonth] = useState<number>(new Date().getMonth() + 1);
  const [year, setYear] = useState<number>(new Date().getFullYear());

  return (
    <>
      <SalaryTable
        managerId={managerId}
        month={month}
        year={year}
        onMonthChange={setMonth}
        onYearChange={setYear}
      />
      {/* <SalaryCalculation managerId={managerId} month={month} year={year} /> */}
    </>
  );
};
